import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';

import { Account } from '@libs/src/models/account.model';
import { IAppState } from '@main-client/src/app/app.state';

import isEmpty from 'lodash-es/isEmpty';

@Injectable()
export class ProfileSelfQueryParamGuardService implements CanActivate {
  constructor(
    public router: Router,
    public store: Store<IAppState>,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.select('user').pipe(
      filter((user: Account) => !isEmpty(user)),
      take(1),
      map((user: Account) => {
        const profileSlug = route.paramMap.get('profileSlug');
        const isUser = route.paramMap.get('profileSlug') === user.slug;
        const isMeQueryParam = route.queryParamMap.get('isMe');
        const isRoutingMode = route.queryParamMap.get('mode');
        if (
          (isUser && 'true' === isMeQueryParam) ||
          (!isUser && !isMeQueryParam)
        ) {
          return true;
        }
        return this.router.createUrlTree(
          ['/profile', profileSlug, ...(isRoutingMode ? ['scorecard'] : [])],
          {
            queryParams: {
              ...route.queryParams,
              isMe: isUser ? true : null,
            },
          },
        );
      }),
    );
  }
}
